import React, { Suspense, lazy } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Main from '../layouts/Main'
import MainAdmin from '../layouts/MainAdmin'

// views
const Login = lazy(() => import('../views/admin/login'))

const HomePage = lazy(() => import('../views/pages/home/homePage'))
const AboutPage = lazy(() => import('../views/pages/about/aboutPage'))
const ContactPage = lazy(() => import('../views/pages/contact/contactPage'))
const WebDevelopmentPage = lazy(() => import('../views/pages/service/webDevelopment'))
const MobileAppDevelopmentPage = lazy(() => import('../views/pages/service/mobileappDevelopment'))
const EcommercePage = lazy(() => import('../views/pages/service/ecommerceSolutions'))
const DigitalMarketingPage = lazy(() => import('../views/pages/service/digitalMarketing'))
const NotFound = lazy(() => import('../views/pages/error/404notfound'));

// Admin Views
const Dashboard = lazy(() => import('../views/admin/dashboard'))

// Review
const CreateReview = lazy(() => import('../views/admin/review'))
const UpdateReview = lazy(() => import('../views/admin/review/update'))
const ListReview = lazy(() => import('../views/admin/review/list'))
const Services = lazy(() => import('../views/admin/services'))
const Gallery = lazy(() => import('../views/admin/gallery'))
const Contact = lazy(() => import('../views/admin/contact'))

const RouterComponent = () => {

  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Switch>
          <Route path='/login' component={Login} />


          {/* Dashboard */}
          <Route path='/admin/dashboard/:path?' exact>
            <MainAdmin>
              <Switch>
                <Route path='/admin/dashboard' exact component={Dashboard} />
              </Switch>
            </MainAdmin>
          </Route>

          {/* Review */}
          <Route path='/admin/create-review/:path?' exact>
            <MainAdmin>
              <Switch>
                <Route path='/admin/create-review' exact component={CreateReview} />
              </Switch>
            </MainAdmin>
          </Route>
          <Route path='/admin/list-reviews/:path?' exact>
            <MainAdmin>
              <Switch>
                <Route path='/admin/list-reviews' exact component={ListReview} />
              </Switch>
            </MainAdmin>
          </Route>
          <Route path='/admin/update-review/:path?' exact>
            <MainAdmin>
              <Switch>
                <Route path='/admin/update-review' exact component={UpdateReview} />
              </Switch>
            </MainAdmin>
          </Route>

          <Route path='/admin/services/:path?' exact>
            <MainAdmin>
              <Switch>
                <Route path='/admin/services' exact component={Services} />
              </Switch>
            </MainAdmin>
          </Route>
          <Route path='/admin/gallery/:path?' exact>
            <MainAdmin>
              <Switch>
                <Route path='/admin/gallery' exact component={Gallery} />
              </Switch>
            </MainAdmin>
          </Route>
          <Route path='/admin/contact/:path?' exact>
            <MainAdmin>
              <Switch>
                <Route path='/admin/contact' exact component={Contact} />
              </Switch>
            </MainAdmin>
          </Route>


          <Route>
            <Main>
              <Switch>
                <Route path='/' exact component={HomePage} />
                <Route path='/about' exact component={AboutPage} />
                <Route path='/contact' exact component={ContactPage} />
                <Route path='/web-app-development' exact component={WebDevelopmentPage} />
                <Route path='/mobile-app-development' exact component={MobileAppDevelopmentPage} />
                <Route path='/ecommerce-solutions' exact component={EcommercePage} />
                <Route path='/digital-marketing' exact component={DigitalMarketingPage} />
                <Route path='*' exact={true} component={NotFound} />
              </Switch>
            </Main>
          </Route>


        </Switch>
      </Suspense>
    </Router>
  )

}

export default RouterComponent;

